import { takeLatest } from 'redux-saga/effects';
import getInitialShiftsWorker from './getInitialShiftsWorker';
import updateShiftsWorker from './updateShiftsWorker';
import getEmployeeInfoWorker from './getEmployeeInfoWorker';
import updateEmployeeInfoWorker from './updateEmployeeInfoWorker';
import {
    GET_INITIAL_SHIFT,
    UPDATE_EMPLOYEE_SHIFT,
    GET_EMPLOYEE_INFO,
    UPDATE_EMPLOYEE_INFO
} from 'employee/ManageEmployee/redux.actionTypes';

// Watchers
export default function* () {
    yield takeLatest(GET_INITIAL_SHIFT, getInitialShiftsWorker);
    yield takeLatest(UPDATE_EMPLOYEE_SHIFT, updateShiftsWorker);
    yield takeLatest(GET_EMPLOYEE_INFO, getEmployeeInfoWorker);
    yield takeLatest(UPDATE_EMPLOYEE_INFO, updateEmployeeInfoWorker);
}
